<template>
  <router-link v-if="route" :to="route" class="block p-4 rounded-lg transition-all duration-150">
    <div class="flex items-center">
      <font-awesome-icon :icon="icon" :size="iconSize" />
      <div class="ml-4">
        <span class="block text-sm leading-tight font-semibold">{{ cardTitle }}</span>
        <strong class="text-2xl" v-if="cardTitleSub">{{
          cardTitleSub
        }}</strong>
      </div>
    </div>

    <span class="block text-sm mt-4 font-semibold" v-if="cardContentTitle">{{
      cardContentTitle
    }}</span>
    <strong class="text-xl leading-none" v-if="cardContentTitle">{{
      cardContent
    }}</strong>
  </router-link>

  <div v-else class="block p-4 rounded-lg transition-all duration-150">
    <div class="flex items-center">
      <font-awesome-icon :icon="icon" :size="iconSize" />
      <div class="ml-4">
        <span class="block text-sm leading-tight font-semibold">{{ cardTitle }}</span>
        <strong class="text-2xl" v-if="cardTitleSub">{{
          cardTitleSub
        }}</strong>
      </div>
    </div>

    <span class="block text-sm mt-4 font-semibold" v-if="cardContentTitle">{{
      cardContentTitle
    }}</span>
    <strong class="text-xl leading-none" v-if="cardContentTitle">{{
      cardContent
    }}</strong>
  </div>
</template>

<script>
export default {
  props: {
    route: {
      type: Object,
      default: null,
    },
    icon: {
      type: Array,
      required: false,
    },
    iconSize: {
      type: String,
      required: false,
    },
    cardTitle: {
      type: String,
      required: false,
      default: null,
    },
    cardTitleSub: {
      required: false,
      default: null,
    },
    cardContentTitle: {
      required: false,
      default: null,
    },
    cardContent: {
      required: false,
      default: null,
    },
  },
};
</script>